/**
 * Renders rich-text (Jodit editor) HTML safely styled.
 * Use this anywhere editor content is shown so tags never appear as raw text.
 * The `.rich-content` styles (lists, headings, links, images) live in index.css.
 */
export default function RichText({ html, className = "" }) {
  if (!html) return null;
  return (
    <div
      className={`rich-content ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
